const withBasePath = (path) => `/client/${path}`;

export const LOGIN = withBasePath('login');
export const RESET_PASSWORD = withBasePath('reset-password/:token');
export const REQUEST_RESET_PASSWORD = withBasePath('request-reset-password');
export const REGISTER_USER = withBasePath('register');
export const COMPLETE_REGISTRATION = withBasePath('complete-registration/:token');
export const PUBLIC_WORLD_MAP = withBasePath('2bea5076-ace2-499e-9b20-53a182ff4e60');
